/**
 * MAP-24 — the marker-shape glyph set, shared by the Style panel's shape picker
 * and the legend's shape-by rows so both name a shape with the SAME icon. The pin
 * variants use the map-pin glyphs (dotted vs plain, matching how they render);
 * the rest are their namesake Lucide shapes.
 */

import { Circle, Diamond, Hexagon, MapPin, MapPinned, Square, Star, Triangle, type LucideIcon } from "@/components";
import type { MarkerShape } from "@/lib/map";

export const SHAPE_ICONS: Record<MarkerShape, LucideIcon> = {
  pin: MapPinned,
  "pin-solid": MapPin,
  circle: Circle,
  square: Square,
  diamond: Diamond,
  triangle: Triangle,
  star: Star,
  hexagon: Hexagon,
};
